import { render } from "./AIBadge.vue?vue&type=template&id=aca50910&scoped=true"
import script from "./AIBadge.vue?vue&type=script&lang=js"
export * from "./AIBadge.vue?vue&type=script&lang=js"

import "./AIBadge.vue?vue&type=style&index=0&id=aca50910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca50910"]])

export default __exports__